import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobalStore } from '../../providers/GlobalStoreProvider';
import Routes from '../routes.enum';

interface ContractEnabledGuardProps {
  children: ReactNode;
}

const ContractEnabledGuard = ({ children }: ContractEnabledGuardProps) => {
  const { agency } = useGlobalStore();

  if (agency.data && !agency.data.enabledListingTypes?.includes('CONTRACTS')) {
    return <Navigate to={Routes.Dashboard} replace />;
  }

  return children;
};

export default ContractEnabledGuard;
